import { GetterTree } from 'vuex';
import { navigation, rootStore } from "@/store/types";

export type Getters = {
    getInitial(state: navigation): boolean;
    getCurrentIndex(state: navigation): number;
    getCurrentTitle(state: navigation): (index: number) => string;
    getCurrentDescription(state: navigation): (index: number) => string;
    getLeftArrowVisible(state: navigation): (index: number) => boolean;
    getRightArrowVisible(state: navigation): (index: number) => boolean;
    getNextRoute(state: navigation): (index: number) => string;
    getPreviousRoute(state: navigation): (index: number) => string;
}

export const getters: GetterTree<navigation, rootStore> & Getters = {
    getInitial(state: navigation): boolean {
        return state.initialization
    },
    getCurrentIndex(state: navigation): number {
        return state.currentIndex;
    },
    getLeftArrowVisible(state: navigation): (index: number) => boolean {
        return (index) =>{
            return state.points[index].leftArrow;
        }
    },
    getRightArrowVisible(state: navigation): (index: number) => boolean {
        return (index) =>{
            return state.points[index].rightArrow;
        }
    },
    getCurrentTitle(state: navigation): (index: number) => string {
        return (index) =>{
            return state.points[index].name;
        }
    },
    getCurrentDescription(state: navigation): (index: number) => string {
        return (index) =>{
            return state.points[index].description;
        }
    },
    getNextRoute(state: navigation): (index: number) => string {
        return (index) =>{
            return state.points[index].nextRoute;
        }
    },
    getPreviousRoute(state: navigation): (index: number) => string {
        return (index) =>{
            return state.points[index].prevRoute;
        }
    }
};